/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Connections_Disconnect_NotetakerInputs */



/**
* | output |
* | --- |
* | "The notetaker will no longer join your conversations." |
*
* @param {Connections_Disconnect_NotetakerInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const connections_disconnect_notetaker = /** @type {((inputs?: Connections_Disconnect_NotetakerInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Connections_Disconnect_NotetakerInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("De notetaker sluit niet meer aan bij je gesprekken.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le notetaker ne rejoint plus vos conversations.")
	return /** @type {LocalizedString} */ ("The notetaker will no longer join your conversations.")
});